module.exports = __webpack_public_path__ + "img/slide-34.0349d604.png";